export default __webpack_public_path__ + "static/edith-490004254182794871ab22c3b5fb3bf8.png";